import React from 'react';

type SkipLinksProps = {
  className?: string;
};

export const SkipLinks = React.memo(function SkipLinks({ className }: SkipLinksProps) {
  const handleSkip = (targetSelector: string) => (e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault();
    const target = document.querySelector(targetSelector);
    if (target instanceof HTMLElement) {
      target.tabIndex = -1;
      target.focus();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav
      className={`skip-links ${className || ''}`}
      aria-label="Skip navigation"
    >
      <a
        href="#main-content"
        className="skip-link"
        onClick={handleSkip('section[aria-label="Code editor"]')}
        onKeyDown={(e) => e.key === 'Enter' && handleSkip('section[aria-label="Code editor"]')(e)}
      >
        Skip to editor
      </a>
      <a
        href="#sidebar"
        className="skip-link"
        onClick={handleSkip('aside[aria-label="File explorer sidebar"]')}
        onKeyDown={(e) => e.key === 'Enter' && handleSkip('aside[aria-label="File explorer sidebar"]')(e)}
      >
        Skip to file explorer
      </a>
      <a
        href="#preview"
        className="skip-link"
        onClick={handleSkip('aside[aria-label="Preview and output panel"]')}
        onKeyDown={(e) => e.key === 'Enter' && handleSkip('aside[aria-label="Preview and output panel"]')(e)}
      >
        Skip to preview
      </a>
    </nav>
  );
});

export default SkipLinks;
